module.exports = __webpack_public_path__ + "resources/img/facetec-ui-customizations-01.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/facetec-ui-customizations-01.png
// module id = 1376
// module chunks = 0